import { render, staticRenderFns } from "./epubread.vue?vue&type=template&id=521a3dc0&scoped=true&"
import script from "./epubread.vue?vue&type=script&lang=js&"
export * from "./epubread.vue?vue&type=script&lang=js&"
import style0 from "./epubread.vue?vue&type=style&index=0&id=521a3dc0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a3dc0",
  null
  
)

export default component.exports